





























import Vue from 'vue';
import { defineComponent, onMounted } from '@vue/composition-api';
import HButtonIcon from '@/ui/components/base/HButtonIcon.vue';
import HToast from '@/ui/components/base/HToast.vue';
import useI18n from '@/ui/composables/base/use-i18n';
import useReviewActionsVariables from '@/ui/composables/review-actions/use-review-actions-variables';
import useLikeReviewVariables from '@/ui/composables/review-actions/use-like-review-variables';
import useLikeReviewFunctions from '@/ui/composables/review-actions/use-like-review-functions';
import useShareReviewFunctions from '@/ui/composables/review-actions/use-share-review-functions';
import useShareReviewVariables from '@/ui/composables/review-actions/use-share-review-variables';
import { iReview } from '../../../entities/review/review.types';

export default defineComponent({
  name: 'ReviewActions',
  components: {
    HButtonIcon,
    HToast,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root, refs }) {
    const { getText } = useI18n(root);
    const reviewActionsVariables = useReviewActionsVariables();
    const likeReviewVariables = useLikeReviewVariables(root.$store, reviewActionsVariables);
    const shareReviewVariables = useShareReviewVariables();
    const reviewFunctions = useLikeReviewFunctions(
      root.$store,
      reviewActionsVariables,
      likeReviewVariables,
    );

    const shareFunctions = useShareReviewFunctions({
      $store: root.$store,
      $refs: refs,
      reviewActionsVariables,
      shareReviewVariables,
      getText,
    });

    onMounted(() => {
      const { reviewInstance } = reviewActionsVariables;
      Vue.set(reviewInstance, 'value', props.review as iReview);
    });

    return {
      ...reviewFunctions,
      ...reviewActionsVariables,
      ...likeReviewVariables,
      ...shareReviewVariables,
      ...shareFunctions,
    };
  },
});
